import React from "react";
import LogoShape from "../../assets/images/biggest_fan_logo_2.svg";
import Image from "./Image";

const Title = ({ title }) => {
  return (
    <>
      <div className="relative z-0 flex items-center pl-10">
        <div className="absolute z-[-1] w-14 xls:w-20 aspect-square flex top-2 left-0 -translate-y-1/2">
          <Image src={LogoShape} alt={""} effect={"blur"} classes={"object-contain"} />
        </div>
        <h2 className="text-lg sm:text-xl xls:text-2xl font-bold">{title}</h2>
      </div>
    </>
  );
};

export default Title;
